import { useToggleState } from '@cian/react-utils';
import { Checkbox } from '@cian/ui-kit';
import * as React from 'react';
import styles from './Floor.css';
import cn from 'classnames';
import { EAreaPartsField } from '../../../../../enums';
import { AreaPartInput } from '../../../../AreaPartInput/AreaPartInput';
import { MAX_FLOOR } from './internal/components/constants';
import { FloorInputsExpanded } from './internal/components/FloorInputsExpanded/FloorInputsExpanded';
import { IFloorProps } from './types';
import { Field } from '../Field';

export const Floor: React.FC<IFloorProps> = props => {
  const { floorFrom, floorTo, isMobile, id, onChange, onValidate, invalidFields } = props;

  const initialIsChecked = floorTo != null;
  const { state: isChecked, toggle: toggleIsChecked } = useToggleState(initialIsChecked);

  const validateFloors = React.useCallback(() => {
    onValidate(EAreaPartsField.FloorFrom);
    onValidate(EAreaPartsField.FloorTo);
  }, [onValidate]);

  const toggleFloorInputs = React.useCallback(() => {
    toggleIsChecked();
    onChange(EAreaPartsField.FloorTo, isChecked ? undefined : null);
  }, [onChange, toggleIsChecked, isChecked]);

  React.useEffect(() => {
    if (invalidFields?.floorFrom != null && invalidFields?.floorTo != null) {
      if (isChecked) {
        validateFloors();

        return;
      }
      onValidate(EAreaPartsField.FloorFrom);
    }
  }, [isChecked]);

  const renderInputs = () => {
    if (isChecked) {
      return <FloorInputsExpanded {...props} onValidate={validateFloors} />;
    }

    return (
      <Field invalidFields={invalidFields} name={EAreaPartsField.FloorFrom} onValidate={onValidate}>
        <AreaPartInput
          value={floorFrom}
          id={id}
          maxWidth={48}
          onChange={onChange}
          name={EAreaPartsField.FloorFrom}
          maxValue={MAX_FLOOR}
        />
      </Field>
    );
  };

  return (
    <div className={cn(styles['container'], isMobile && styles['mobile'])}>
      {renderInputs()}
      <div className={styles['checkbox-container']}>
        <Checkbox label="Помещение расположено на нескольких этажах" checked={isChecked} onChange={toggleFloorInputs} />
      </div>
    </div>
  );
};
